import React, { Component } from "react";
import DigitalSignature from "../../../components/FormComponent/digitalSignature";
import { signatureSchema, } from './../../../schema/new-estimate-charges-cash';

class SignaturePage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            signatureSchema: signatureSchema["feilds"],
        }
    }
    render(){
        const {signatureSchema,} = this.state;
        return (
            <>
                {signatureSchema && signatureSchema.map((fei, fei_key) => {
                    if(fei["element"] === "signature_pad"){
                        return (
                            <>
                                {/* <label className="data-label w-100 mb-1 pt-2">{fei["title"]}</label> */}
                                <DigitalSignature feild={fei} {...this.props}/>
                            </>
                        )
                    }
                })}
            </>
        )
    }
}
export default SignaturePage;